import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { ResourceIdDto } from '@/api/generated';
import { refreshThreadList } from '@/views/emails/util/threadListCache.util.ts';

type Req = {
  emailThreadId: string;
  resource: ResourceIdDto;
};

type Return = {
  isRemoving: boolean;
  removeThreadFromResource: (req: Req) => Promise<void>;
};

export const useRemoveThreadFromResource = (): Return => {
  const { resourceThreadApi } = useProcessApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async req => {
      await resourceThreadApi.removeThread(
        req.emailThreadId,
        req.resource.resourceId,
        req.resource.type,
      );
    },
    onSuccess: async () => {
      await refreshThreadList(queryClient);
    },
  });

  return {
    isRemoving: isPending,
    removeThreadFromResource: mutateAsync,
  };
};
